var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConteudoBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14583 10.25H10.8333V8.99996H6.14583V10.25ZM6.14583 8.37496H14.375V7.12496H6.14583V8.37496ZM6.14583 6.49996H14.375V5.24996H6.14583V6.49996ZM4.41666 14.8333C4.08333 14.8333 3.79166 14.7083 3.54166 14.4583C3.29166 14.2083 3.16666 13.9166 3.16666 13.5833V1.91663C3.16666 1.58329 3.29166 1.29163 3.54166 1.04163C3.79166 0.791626 4.08333 0.666626 4.41666 0.666626H16.0833C16.4167 0.666626 16.7083 0.791626 16.9583 1.04163C17.2083 1.29163 17.3333 1.58329 17.3333 1.91663V13.5833C17.3333 13.9166 17.2083 14.2083 16.9583 14.4583C16.7083 14.7083 16.4167 14.8333 16.0833 14.8333H4.41666ZM4.41666 13.5833H16.0833V1.91663H4.41666V13.5833ZM1.91666 17.3333C1.58333 17.3333 1.29166 17.2083 1.04166 16.9583C0.791664 16.7083 0.666664 16.4166 0.666664 16.0833V3.16663H1.91666V16.0833H14.8333V17.3333H1.91666ZM4.41666 1.91663V13.5833V1.91663Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConteudoBranco);
export default __webpack_public_path__ + "static/media/conteudoBranco.adb1634935f6abf5997742b828620ed7.svg";
export { ForwardRef as ReactComponent };